export default __webpack_public_path__ + "static/Metamask-30eeac05b0ed679c4443d8d4783886d2.png";